var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.months,"label":_vm.label,"value":_vm.value,"item-text":"name","item-value":"key"},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }